import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { createNewClozeQuestionAnswerData } from '@/contentObjects/ClozeQuestionAnswer/create';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { Feedbacks } from '@/utils/feedback.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { manifestLocales } from '@/widgets/ClozeQuestion/manifest.locales';
import { getEvaluationProps } from '@/widgets/consts/getEvaluationProps';
import { createQuestionWidgetChildren } from '@/widgets/utils/createQuestionWidgetChildren';

export enum ClozeQuestionType {
  Default = 'default',
  Table = 'table'
}

export function createNewClozeQuestionDataBase(options: InitializePropsOptions) {
  const { isPlenaryLesson, locale } = options;

  const { answerPlaceholder, initialHeadlineText } = manifestLocales.clozeQuestion;
  const id = genRandId();
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const answerFragment = htmlToXmlFragment('<p></p>');
  const hintFragment = htmlToXmlFragment('<p></p>');
  const widgetEvaluationProps = Object.entries(getEvaluationProps(isPlenaryLesson));

  const [questionAnswerData] = createNewClozeQuestionAnswerData();
  const { childrenArray, horizontalFlexSectionData, verticalFlexSectionData } = createQuestionWidgetChildren(
    questionAnswerData.id,
    options?.width
  );

  return {
    id,
    contentObjectData: [
      ['id', id],
      ['type', WidgetType.ClozeQuestion],
      ['children', childrenArray],
      ['labelFragment', labelFragment],
      ['answerFragment', answerFragment],
      ['hintFragment', hintFragment],
      ['answerPlaceholder', answerPlaceholder[locale]],
      ['clozeOptions', new Y.Map()],
      ['selectPossibleOptions', new Y.Map()],
      ['withRandomAnswers', new Y.Map()],
      ['feedback', Feedbacks.Check],
      ['saveAnswers', true],
      ...widgetEvaluationProps,
      ['questionAnswerId', questionAnswerData.id],
      ['clozeQuestionType', ClozeQuestionType.Default]
    ],
    sensitiveData: [
      ['inputCorrectOptions', new Y.Map()],
      ['selectCorrectOptions', new Y.Map()]
    ],
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  } as const;
}

export function createNewClozeQuestionData(options: InitializePropsOptions): ManifestInitializedProps {
  const {
    contentObjectData,
    horizontalFlexSectionData,
    id,
    questionAnswerData,
    sensitiveData,
    verticalFlexSectionData
  } = createNewClozeQuestionDataBase(options);
  return [
    {
      id,
      contentObjectData: new Y.Map(contentObjectData),
      sensitiveData: new Y.Map(sensitiveData)
    },
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  ];
}
